import { Injectable } from '@angular/core'

import { Upload } from '../entities/upload'
import { AuthService } from '../services/AuthService'
import { ProductService } from '../services/product.service'
import { NewsService } from '../services/newsService'
import { BuyService } from '../services/buyservice'
import { AngularFireDatabase, FirebaseListObservable } from "angularfire2/database-deprecated";
import * as firebase from 'firebase'




@Injectable()
export class uploadService {

    checkClick = true;
    checkClickAdvertise = true;
    checkClickaddProduct = true;
    checkClickaddNew = true;
    constructor(private nSr: NewsService, private db: AngularFireDatabase, private auth: AuthService, private buy: BuyService, private product: ProductService) {

    }
    private basePath: string = '/' + this.auth.email;
    private basePathProduct: string = '/product';
    private basePathNews: string = '/News';
    private basePathAdver: string = '/advertisement';
    private uploadTask: firebase.storage.UploadTask

    private uploadTask1: firebase.storage.UploadTask
    private uploadTask2: firebase.storage.UploadTask
    private uploadTask3: firebase.storage.UploadTask
    private uploadTask4: firebase.storage.UploadTask


    private image;
    UpProductimage(upload: Upload,idd,type) {
        this.checkClickaddProduct=false;
        let storageRef = firebase.storage().ref();
        this.uploadTask = storageRef.child(`${this.basePathProduct}/${upload.file.name}`).put(upload.file)
        this.uploadTask.then(res => {
            // this.checkClickaddProduct=true;
            // dataItem.photo = this.uploadTask.snapshot.downloadURL
            this.product.UpdateData(idd,this.uploadTask.snapshot.downloadURL,type)
        })
    }

    // =================================
    // Function Upload Image add Product
    // =================================
    pushUpload(upload: Upload, id: string) {
        let storageRef = firebase.storage().ref();
        this.uploadTask = storageRef.child(`${this.basePath}/${upload.file.name}`).put(upload.file)
        this.uploadTask.on(firebase.storage.TaskEvent.STATE_CHANGED, (snapshot) => {
            upload.progress = (this.uploadTask.snapshot.bytesTransferred / this.uploadTask.snapshot.totalBytes) * 100
            // console.log(upload.progress)
            if (upload.progress == 100) {
                let path = `${this.basePath}/${upload.file.name}`
                this.buy.updatedataUpload(id, path)
            }
        })
    }

    // =================================
    // add Product with Image product
    // =================================
    addUpProduct(dataItem, upload: Upload) {
        this.checkClickaddProduct=false;
        let storageRef = firebase.storage().ref();
        this.uploadTask = storageRef.child(`${this.basePathProduct}/${upload.file.name}`).put(upload.file)
        this.uploadTask.then(res => {
            this.checkClickaddProduct=true;
            dataItem.photo = this.uploadTask.snapshot.downloadURL
            this.buy.addProductsitem(dataItem)
        })
    }
    addUpProduct2Image(dataItem, upload: Upload, upload2: Upload) {
        this.checkClickaddProduct=false;
        let storageRef = firebase.storage().ref();
        this.uploadTask = storageRef.child(`${this.basePathProduct}/${upload.file.name}`).put(upload.file)
        this.uploadTask.then(res => {
            this.checkClickaddProduct=true;
            dataItem.photo = this.uploadTask.snapshot.downloadURL

            this.uploadTask2 = storageRef.child(`${this.basePathProduct}/${upload2.file.name}`).put(upload2.file)
            this.uploadTask2.then(res => {
                dataItem.photo2 = this.uploadTask2.snapshot.downloadURL
                this.buy.addProductsitem(dataItem)

            })
        })
    }
    addUpProduct3Image(dataItem, upload: Upload, upload2: Upload, upload3: Upload) {
        this.checkClickaddProduct=false;
        let storageRef = firebase.storage().ref();
        this.uploadTask = storageRef.child(`${this.basePathProduct}/${upload.file.name}`).put(upload.file)
        this.uploadTask.then(res => {
            dataItem.photo = this.uploadTask.snapshot.downloadURL

            this.uploadTask2 = storageRef.child(`${this.basePathProduct}/${upload2.file.name}`).put(upload2.file)
            this.uploadTask2.then(res => {
                dataItem.photo2 = this.uploadTask2.snapshot.downloadURL

                this.uploadTask3 = storageRef.child(`${this.basePathProduct}/${upload3.file.name}`).put(upload3.file)
                this.uploadTask3.then(res => {
                    this.checkClickaddProduct=true;
                    dataItem.photo3 = this.uploadTask3.snapshot.downloadURL
                    this.buy.addProductsitem(dataItem)
                })

            })

        })
    }
    // =================================
    // function Update Product 
    // =================================
    UpdateAdvertise(dataItem, upload: Upload, idd) {
        let storageRef = firebase.storage().ref();
        this.uploadTask = storageRef.child(`${this.basePathAdver}/${upload.file.name}`).put(upload.file)
        // Save path Image 
        this.uploadTask.then(res => {
            dataItem.pathimg = this.uploadTask.snapshot.downloadURL
            this.nSr.updateAdvertise(dataItem, idd)
        })
    }
    // =================================
    // function Update Product 
    // =================================
    UpdateProduct(dataItem, upload: Upload, idd) {
        this.checkClick = false;
        let storageRef = firebase.storage().ref();
        this.uploadTask = storageRef.child(`${this.basePathProduct}/${upload.file.name}`).put(upload.file)
        // Save path Image 
        this.uploadTask.then(res => {
            this.checkClick = true;
            dataItem.photo = this.uploadTask.snapshot.downloadURL;
            this.product.UpdateProductWithImage(dataItem, idd)
        })
    }
    UpdateProduct2(dataItem, upload: Upload, upload2: Upload, idd) {
        this.checkClick = false;
        let storageRef = firebase.storage().ref();
        this.uploadTask = storageRef.child(`${this.basePathProduct}/${upload.file.name}`).put(upload.file)
        // Save path Image 
        this.uploadTask.then(res => {
            dataItem.photo = this.uploadTask.snapshot.downloadURL;

            this.uploadTask2 = storageRef.child(`${this.basePathProduct}/${upload2.file.name}`).put(upload2.file)
            // Save path Image 
            this.uploadTask2.then(res => {
                this.checkClick = true;
                dataItem.photo1 = this.uploadTask2.snapshot.downloadURL;
                this.product.UpdateProductWithImage(dataItem, idd)
            })
        })
    }
    UpdateProduct3(dataItem, upload: Upload, upload2: Upload, upload3: Upload, idd) {
        this.checkClick = false;
        let storageRef = firebase.storage().ref();
        this.uploadTask = storageRef.child(`${this.basePathProduct}/${upload.file.name}`).put(upload.file)
        // Save path Image 
        this.uploadTask.then(res => {
            dataItem.photo = this.uploadTask.snapshot.downloadURL;

            this.uploadTask2 = storageRef.child(`${this.basePathProduct}/${upload2.file.name}`).put(upload2.file)
            // Save path Image 
            this.uploadTask2.then(res => {
                dataItem.photo2 = this.uploadTask2.snapshot.downloadURL;

                this.uploadTask3 = storageRef.child(`${this.basePathProduct}/${upload3.file.name}`).put(upload3.file)
                // Save path Image 
                this.uploadTask3.then(res => {
                    this.checkClick = true;
                    dataItem.photo3 = this.uploadTask3.snapshot.downloadURL;
                    this.product.UpdateProductWithImage(dataItem, idd)
                })
            })

        })
    }
    // =================================
    // function Update Product 
    // =================================
    UpdateProductDrirect(dataItem, idd) {
        this.product.updateProduct(dataItem, idd)
    }

    // Function Upload Image news
    addNews(dataItem, upload: Upload) {

        let date = new Date()
        let day = date.getDate()
        let month = date.getMonth()
        let Year = date.getFullYear()

        dataItem.date = day + '-' + month + '-' + Year

        let storageRef = firebase.storage().ref();
        this.uploadTask = storageRef.child(`${this.basePathNews}/${upload.file.name}`).put(upload.file)
        let path = `${this.basePathNews}/${upload.file.name}`
        dataItem.photo = path

        this.uploadTask.on(firebase.storage.TaskEvent.STATE_CHANGED, (snapshot) => {
            upload.progress = (this.uploadTask.snapshot.bytesTransferred / this.uploadTask.snapshot.totalBytes) * 100
            if (upload.progress == 100) {
                this.nSr.addNew(dataItem)
            }
        })
    }


    // =============================
    // Function Upload Advertisement
    // =============================
    addAdvertise(data, upload: Upload) {

        let storageRef = firebase.storage().ref();
        this.uploadTask = storageRef.child(`${this.basePathAdver}/${upload.file.name}`).put(upload.file)
        let path = `${this.basePathAdver}/${upload.file.name}`
        data.pathimg = path
        this.uploadTask.then(response=>{
            data.pathimg = this.uploadTask.snapshot.downloadURL
            this.nSr.addAdvertisement(data)
        }), (error) => {
            console.log(error)
        }
    }

    // ==========================
    // Function Upload Image News
    // ==========================
    addMoreManyImageNewTitle(dataItem, uploadTitle: Upload) {
        this.checkClickaddNew = false;
        let date = new Date()
        let day = date.getDate()
        let month = date.getMonth()
        let Year = date.getFullYear()

        dataItem.date = day + '-' + month + '-' + Year
        let storageRef = firebase.storage().ref();
        this.uploadTask = storageRef.child(`${this.basePathNews}/${uploadTitle.file.name}`).put(uploadTitle.file)

        this.uploadTask.on(firebase.storage.TaskEvent.STATE_CHANGED, (snapshot) => {
            uploadTitle.progress = (this.uploadTask.snapshot.bytesTransferred / this.uploadTask.snapshot.totalBytes) * 100
            if (uploadTitle.progress == 100) {
                console.log(dataItem)
                this.checkClickaddNew = true;
                dataItem.photoTitle = this.uploadTask.snapshot.downloadURL
                this.nSr.addNew(dataItem)
            }
        })
    }
    addMoreManyImageNew1(dataItem, uploadTitle: Upload, upload1: Upload) {
        this.checkClickaddNew = false;
        let date = new Date()
        let day = date.getDate()
        let month = date.getMonth()
        let Year = date.getFullYear()

        dataItem.date = day + '-' + month+1 + '-' + Year

        let storageRef = firebase.storage().ref();
        this.uploadTask = storageRef.child(`${this.basePathNews}/${uploadTitle.file.name}`).put(uploadTitle.file)
        this.uploadTask.then(res => {

            dataItem.photoTitle = this.uploadTask.snapshot.downloadURL

            this.uploadTask1 = storageRef.child(`${this.basePathNews}/${upload1.file.name}`).put(upload1.file)
            this.uploadTask1.then(res => {
                this.checkClickaddNew = true;
                dataItem.photo1 = this.uploadTask1.snapshot.downloadURL
                this.nSr.addNew(dataItem)
            })
        })
    }
    addMoreManyImageNew2(dataItem, uploadTitle: Upload, upload1: Upload, upload2: Upload) {
        this.checkClickaddNew = false;
        let date = new Date()
        let day = date.getDate()
        let month = date.getMonth()
        let Year = date.getFullYear()

        let storageRef = firebase.storage().ref();
        this.uploadTask = storageRef.child(`${this.basePathNews}/${uploadTitle.file.name}`).put(uploadTitle.file)
        this.uploadTask.then(res => {

            dataItem.photoTitle = this.uploadTask.snapshot.downloadURL

            this.uploadTask1 = storageRef.child(`${this.basePathNews}/${upload1.file.name}`).put(upload1.file)
            this.uploadTask1.then(res => {
                dataItem.photo1 = this.uploadTask1.snapshot.downloadURL

                this.uploadTask2 = storageRef.child(`${this.basePathNews}/${upload2.file.name}`).put(upload2.file)
                this.uploadTask2.then(res => {
                    this.checkClickaddNew = true;
                    dataItem.photo2 = this.uploadTask2.snapshot.downloadURL
                    this.nSr.addNew(dataItem)
                })
            })

        })
    }
    addMoreManyImageNew3(dataItem, uploadTitle: Upload, upload1: Upload, upload2: Upload, upload3: Upload) {
        this.checkClickaddNew = false;
        let date = new Date()
        let day = date.getDate()
        let month = date.getMonth()
        let Year = date.getFullYear()

        let storageRef = firebase.storage().ref();
        this.uploadTask = storageRef.child(`${this.basePathNews}/${uploadTitle.file.name}`).put(uploadTitle.file)
        this.uploadTask.then(res => {

            dataItem.photoTitle = this.uploadTask.snapshot.downloadURL

            this.uploadTask1 = storageRef.child(`${this.basePathNews}/${upload1.file.name}`).put(upload1.file)
            this.uploadTask1.then(res => {
                dataItem.photo1 = this.uploadTask1.snapshot.downloadURL
                this.uploadTask2 = storageRef.child(`${this.basePathNews}/${upload2.file.name}`).put(upload2.file)
                this.uploadTask2.then(res => {
                    dataItem.photo2 = this.uploadTask2.snapshot.downloadURL
                    this.uploadTask3 = storageRef.child(`${this.basePathNews}/${upload3.file.name}`).put(upload3.file)
                    this.uploadTask3.then(res => {
                        this.checkClickaddNew = true;
                        dataItem.photo3 = this.uploadTask3.snapshot.downloadURL
                        this.nSr.addNew(dataItem)
                    })
                })

            })

        })
    }
    addMoreManyImageNew4(dataItem, uploadTitle: Upload, upload1: Upload, upload2: Upload, upload3: Upload, upload4: Upload) {
        this.checkClickaddNew = false;
        let date = new Date()
        let day = date.getDate()
        let month = date.getMonth()
        let Year = date.getFullYear()

        let storageRef = firebase.storage().ref();
        this.uploadTask = storageRef.child(`${this.basePathNews}/${uploadTitle.file.name}`).put(uploadTitle.file)
        this.uploadTask.then(res => {

            dataItem.photoTitle = this.uploadTask.snapshot.downloadURL

            this.uploadTask1 = storageRef.child(`${this.basePathNews}/${upload1.file.name}`).put(upload1.file)
            this.uploadTask1.then(res => {
                dataItem.photo1 = this.uploadTask1.snapshot.downloadURL
                this.uploadTask2 = storageRef.child(`${this.basePathNews}/${upload2.file.name}`).put(upload2.file)
                this.uploadTask2.then(res => {
                    dataItem.photo2 = this.uploadTask2.snapshot.downloadURL
                    this.uploadTask3 = storageRef.child(`${this.basePathNews}/${upload3.file.name}`).put(upload3.file)
                    this.uploadTask3.then(res => {
                        dataItem.photo3 = this.uploadTask3.snapshot.downloadURL
                        this.uploadTask4 = storageRef.child(`${this.basePathNews}/${upload4.file.name}`).put(upload4.file)
                        this.uploadTask4.then(res => {
                            this.checkClickaddNew = true;
                            dataItem.photo4 = this.uploadTask4.snapshot.downloadURL
                            this.nSr.addNew(dataItem)
                        })
                    })
                })
            })
        })
    }

    // ==========================
    // Function Upload Image News
    // ==========================
    upImageNewTitle(dataItem, uploadTitle: Upload) {
        
        let date = new Date()
        let day = date.getDate()
        let month = date.getMonth()
        let Year = date.getFullYear()

        dataItem.date = day + '-' + month + '-' + Year

        let storageRef = firebase.storage().ref();
        this.uploadTask = storageRef.child(`${this.basePathNews}/${uploadTitle.file.name}`).put(uploadTitle.file)

        this.uploadTask.on(firebase.storage.TaskEvent.STATE_CHANGED, (snapshot) => {
            uploadTitle.progress = (this.uploadTask.snapshot.bytesTransferred / this.uploadTask.snapshot.totalBytes) * 100
            if (uploadTitle.progress == 100) {
                dataItem.photoTitle = this.uploadTask.snapshot.downloadURL
                //this.nSr.addNew(dataItem)
            }
        })
    }
    upImageNew1(dataItem, uploadTitle: Upload, upload1: Upload) {
        let date = new Date()
        let day = date.getDate()
        let month = date.getMonth()
        let Year = date.getFullYear()

        dataItem.date = day + '-' + month + '-' + Year

        let storageRef = firebase.storage().ref();
        this.uploadTask = storageRef.child(`${this.basePathNews}/${uploadTitle.file.name}`).put(uploadTitle.file)
        this.uploadTask.then(res => {

            dataItem.photoTitle = this.uploadTask.snapshot.downloadURL

            this.uploadTask1 = storageRef.child(`${this.basePathNews}/${upload1.file.name}`).put(upload1.file)
            this.uploadTask1.then(res => {
                dataItem.photo1 = this.uploadTask1.snapshot.downloadURL
                //this.nSr.addNew(dataItem)
            })
        })
    }
    upImageNew2(dataItem, uploadTitle: Upload, upload1: Upload, upload2: Upload) {
        let date = new Date()
        let day = date.getDate()
        let month = date.getMonth()
        let Year = date.getFullYear()

        let storageRef = firebase.storage().ref();
        this.uploadTask = storageRef.child(`${this.basePathNews}/${uploadTitle.file.name}`).put(uploadTitle.file)
        this.uploadTask.then(res => {

            dataItem.photoTitle = this.uploadTask.snapshot.downloadURL

            this.uploadTask1 = storageRef.child(`${this.basePathNews}/${upload1.file.name}`).put(upload1.file)
            this.uploadTask1.then(res => {
                dataItem.photo1 = this.uploadTask1.snapshot.downloadURL

                this.uploadTask2 = storageRef.child(`${this.basePathNews}/${upload2.file.name}`).put(upload2.file)
                this.uploadTask2.then(res => {
                    dataItem.photo2 = this.uploadTask2.snapshot.downloadURL
                    //this.nSr.addNew(dataItem)
                })
            })

        })
    }
    upImageNew3(dataItem, uploadTitle: Upload, upload1: Upload, upload2: Upload, upload3: Upload) {
        let date = new Date()
        let day = date.getDate()
        let month = date.getMonth()
        let Year = date.getFullYear()

        let storageRef = firebase.storage().ref();
        this.uploadTask = storageRef.child(`${this.basePathNews}/${uploadTitle.file.name}`).put(uploadTitle.file)
        this.uploadTask.then(res => {

            dataItem.photoTitle = this.uploadTask.snapshot.downloadURL

            this.uploadTask1 = storageRef.child(`${this.basePathNews}/${upload1.file.name}`).put(upload1.file)
            this.uploadTask1.then(res => {
                dataItem.photo1 = this.uploadTask1.snapshot.downloadURL
                this.uploadTask2 = storageRef.child(`${this.basePathNews}/${upload2.file.name}`).put(upload2.file)
                this.uploadTask2.then(res => {
                    dataItem.photo2 = this.uploadTask2.snapshot.downloadURL
                    this.uploadTask3 = storageRef.child(`${this.basePathNews}/${upload3.file.name}`).put(upload3.file)
                    this.uploadTask3.then(res => {
                        dataItem.photo3 = this.uploadTask3.snapshot.downloadURL
                        //this.nSr.addNew(dataItem)
                    })
                })

            })

        })
    }
    upImageNew4(dataItem, uploadTitle: Upload, upload1: Upload, upload2: Upload, upload3: Upload, upload4: Upload) {
        let date = new Date()
        let day = date.getDate()
        let month = date.getMonth()
        let Year = date.getFullYear()

        let storageRef = firebase.storage().ref();
        this.uploadTask = storageRef.child(`${this.basePathNews}/${uploadTitle.file.name}`).put(uploadTitle.file)
        this.uploadTask.then(res => {

            dataItem.photoTitle = this.uploadTask.snapshot.downloadURL

            this.uploadTask1 = storageRef.child(`${this.basePathNews}/${upload1.file.name}`).put(upload1.file)
            this.uploadTask1.then(res => {
                dataItem.photo1 = this.uploadTask1.snapshot.downloadURL
                this.uploadTask2 = storageRef.child(`${this.basePathNews}/${upload2.file.name}`).put(upload2.file)
                this.uploadTask2.then(res => {
                    dataItem.photo2 = this.uploadTask2.snapshot.downloadURL
                    this.uploadTask3 = storageRef.child(`${this.basePathNews}/${upload3.file.name}`).put(upload3.file)
                    this.uploadTask3.then(res => {
                        dataItem.photo3 = this.uploadTask3.snapshot.downloadURL
                        this.uploadTask4 = storageRef.child(`${this.basePathNews}/${upload4.file.name}`).put(upload4.file)
                        this.uploadTask4.then(res => {
                            dataItem.photo4 = this.uploadTask4.snapshot.downloadURL
                            //this.nSr.addNew(dataItem)
                        })
                    })
                })
            })
        })
    }
    // ===============================
    // Function Upload UpdateData News
    // ===============================

    upDateNews(dataItem, uploadTitle: Upload, idd) {
        this.checkClickAdvertise = false;
        let storageRef = firebase.storage().ref();
        this.uploadTask = storageRef.child(`${this.basePathNews}/${uploadTitle.file.name}`).put(uploadTitle.file)
        this.uploadTask.then(res => {
            this.checkClickAdvertise = true;
            dataItem.photoTitle = this.uploadTask.snapshot.downloadURL
            this.nSr.updateNews(dataItem, idd)
        })
    }
    upDateNews1(dataItem, uploadTitle: Upload, upload2: Upload, idd) {
        this.checkClickAdvertise = false;
        let storageRef = firebase.storage().ref();
        this.uploadTask = storageRef.child(`${this.basePathNews}/${uploadTitle.file.name}`).put(uploadTitle.file)
        this.uploadTask.then(res => {
            dataItem.photoTitle = this.uploadTask.snapshot.downloadURL

            this.uploadTask2 = storageRef.child(`${this.basePathNews}/${upload2.file.name}`).put(upload2.file)
            this.uploadTask2.then(res => {
                this.checkClickAdvertise = true;
                dataItem.photo1 = this.uploadTask2.snapshot.downloadURL
                this.nSr.updateNews(dataItem, idd)

            })
        })
    }
    upDateNews2(dataItem, uploadTitle: Upload, upload2: Upload, upload3: Upload, idd) {
        this.checkClickAdvertise = false;
        let storageRef = firebase.storage().ref();
        this.uploadTask = storageRef.child(`${this.basePathNews}/${uploadTitle.file.name}`).put(uploadTitle.file)
        this.uploadTask.then(res => {
            dataItem.photoTitle = this.uploadTask.snapshot.downloadURL

            this.uploadTask2 = storageRef.child(`${this.basePathNews}/${upload2.file.name}`).put(upload2.file)
            this.uploadTask2.then(res => {
                dataItem.photo1 = this.uploadTask2.snapshot.downloadURL

                this.uploadTask3 = storageRef.child(`${this.basePathNews}/${upload3.file.name}`).put(upload3.file)
                this.uploadTask3.then(res => {
                    this.checkClickAdvertise = true;
                    dataItem.photo2 = this.uploadTask3.snapshot.downloadURL
                    this.nSr.updateNews(dataItem, idd)

                })

            })
        })
    }
    upDateNews3(dataItem, uploadTitle: Upload, upload2: Upload, upload3: Upload, upload4: Upload, idd) {
        this.checkClickAdvertise = false;
        let storageRef = firebase.storage().ref();
        this.uploadTask = storageRef.child(`${this.basePathNews}/${uploadTitle.file.name}`).put(uploadTitle.file)
        this.uploadTask.then(res => {
            dataItem.photoTitle = this.uploadTask.snapshot.downloadURL

            this.uploadTask2 = storageRef.child(`${this.basePathNews}/${upload2.file.name}`).put(upload2.file)
            this.uploadTask2.then(res => {
                dataItem.photo1 = this.uploadTask2.snapshot.downloadURL

                this.uploadTask3 = storageRef.child(`${this.basePathNews}/${upload3.file.name}`).put(upload3.file)
                this.uploadTask3.then(res => {
                    dataItem.photo2 = this.uploadTask3.snapshot.downloadURL

                    this.uploadTask4 = storageRef.child(`${this.basePathNews}/${upload4.file.name}`).put(upload4.file)
                    this.uploadTask4.then(res => {
                        this.checkClickAdvertise = true;
                        dataItem.photo3 = this.uploadTask4.snapshot.downloadURL
                        this.nSr.updateNews(dataItem, idd)

                    })

                })

            })
        })
    }
    upDateNews4(dataItem, uploadTitle: Upload, upload2: Upload, upload3: Upload, upload4: Upload, upload5: Upload, idd) {
        this.checkClickAdvertise = false;
        let storageRef = firebase.storage().ref();
        this.uploadTask = storageRef.child(`${this.basePathNews}/${uploadTitle.file.name}`).put(uploadTitle.file)
        this.uploadTask.then(res => {
            dataItem.photoTitle = this.uploadTask.snapshot.downloadURL

            this.uploadTask2 = storageRef.child(`${this.basePathNews}/${upload2.file.name}`).put(upload2.file)
            this.uploadTask2.then(res => {
                dataItem.photo1 = this.uploadTask2.snapshot.downloadURL

                this.uploadTask3 = storageRef.child(`${this.basePathNews}/${upload3.file.name}`).put(upload3.file)
                this.uploadTask3.then(res => {
                    dataItem.photo2 = this.uploadTask3.snapshot.downloadURL

                    this.uploadTask4 = storageRef.child(`${this.basePathNews}/${upload4.file.name}`).put(upload4.file)
                    this.uploadTask4.then(res => {
                        dataItem.photo3 = this.uploadTask4.snapshot.downloadURL

                        this.uploadTask1 = storageRef.child(`${this.basePathNews}/${upload5.file.name}`).put(upload5.file)
                        this.uploadTask1.then(res => {
                            this.checkClickAdvertise = true;
                            dataItem.photo4 = this.uploadTask1.snapshot.downloadURL
                            this.nSr.updateNews(dataItem, idd)
                        })
                    })
                })
            })
        })
    }
}


// WEBPACK FOOTER //
// D:/pokpak-v3/pokpak-v2/pokpak-ang/src/app/services/uploadService.ts